import React from 'react';
import {
  bool, number, oneOf, oneOfType, string
} from 'prop-types';
import { Location } from '@one-thd/sui-icons';

export const StorePin = ({ color, index, mini }) => {
  if (mini) {
    return (
      <span className="sui-text-brand">
        {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
        <Location alt="map pin" className="sui-w-[20px] sui-h-[20px]" data-testid="store-pin-mini" />
      </span>
    );
  }

  const pinStyle = {
    textAlign: 'center',
    fontSize: '12px',
    color: '#000',
    fontWeight: 'bold',
    fontFamily: '\'Helvetica Neue\',Helvetica-,Arial,sans-serif'
  };

  return (
    <svg
      data-testid="store-pin"
      width="30px"
      height="39px"
      viewBox="0 0 30 39"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-36.000000, -268.000000)" fill={color}>
          {/* eslint-disable-next-line max-len */}
          <path d="M50.590202,268 C42.8105556,268 36,274.2402 36,281.94205 C36,289.08425 50.4245455,306.1792 50.4245455,306.1792 C50.4245455,306.1792 65.3688384,289.3241 65.3688384,281.94205 C65.3688384,274.2402 58.3677778,268 50.590202,268 L50.590202,268 Z M50.6833838,289.87965 C46.2769192,289.87965 42.7049495,286.3434 42.7049495,281.981 C42.7049495,277.6186 46.2769192,274.0803 50.6833838,274.0803 C55.0919192,274.0803 58.6638889,277.6186 58.6638889,281.981 C58.6638889,286.3434 55.0919192,289.87965 50.6833838,289.87965 L50.6833838,289.87965 Z" />
        </g>
      </g>
      <>
        <circle xmlns="http://www.w3.org/2000/svg" fill="#fff" cx="14.5" cy="14" r="10" />
        {index && (
          <text textAnchor="middle" x="14" y="18" style={pinStyle}>
            {index}
          </text>
        )}
      </>
    </svg>
  );
};

StorePin.propTypes = {
  color: oneOf(['#00AE4D', '#F96302']),
  index: oneOfType([number, string]),
  mini: bool
};

StorePin.defaultProps = {
  color: '#F96302',
  index: null,
  mini: false
};

StorePin.displayName = 'StorePin';
